module.exports = __webpack_public_path__ + "img/Loose Center Stone.2434d76d.png";